import { render, staticRenderFns } from "./RacunZaUplatuForma.vue?vue&type=template&id=44738c14&scoped=true&"
import script from "./RacunZaUplatuForma.vue?vue&type=script&lang=js&"
export * from "./RacunZaUplatuForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44738c14",
  null
  
)

export default component.exports